import React, { Component } from "react";
import { withRouter, Redirect } from 'react-router-dom'
import PageTitle from "../../Theme/PageTitle";
import DashboardLayout from "../../Theme/DashboardLayout";
import { Modal, Switch, message, Tabs, Select, Mentions, Button, Dropdown, Menu } from "antd";
import GanttChartTimeline, {
  TimelineHeaders,
  SidebarHeader,
  TimelineMarkers,
} from 'react-calendar-timeline/lib'
import containerResizeDetector from 'react-calendar-timeline/lib/resize-detector/container';
import './ScheduleView.scss'
import moment from 'moment-timezone'
import groupRendererLive from '../utils/live-schedules/groupRendererLive';
import generateGroups from './utils/generate-timeline/generateGroups';
import generateItems from './utils/generate-timeline/generateItems';
import Spinner from '../../Theme/Spinner';
import CustomPrimaryDateHeader from './CustomPrimaryDateHeader';
import CustomDateHeader from './CustomDateHeader';
import ItemModalDetails from './ItemModalDetails';
import ApprovalFindButton from '../../Approval/ApprovalFindButton';
import { bindActionCreators } from "redux";
import * as liveScheduleActions from '../../../redux/actions/liveScheduleActions';
import * as postedScheduleActions from '../../../redux/actions/postedScheduleActions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LiveSchedulesToggle from "../LiveSchedulesToggle";
import WorkerMultiSelect from '../WorkerMultiSelect';
import AuthLogic from '../../../AuthLogic';
import generateItemDetails from './utils/generateItemDetails';
import contextMenuArrays from '../utils/live-schedules/context-menu-arrays';
import LiveScheduleUpdate from '../LiveScheduleUpdate/LiveScheduleUpdate';
import removeObjectIds from '../utils/removeObjectIds';
import _ from 'lodash';
import liveScheduleActionsMenu from '../utils/live-schedules/drop-down-tables/liveScheduleActionsMenu';
import securityFilter from './utils/live-schedule-view-security-filter';
// import generateListPostedSchedulesArray from '../generateListPostedSchedulesArray';

const { TabPane } = Tabs;
const { Option } = Select;

const scheduleType = 'liveSchedule';

class LiveScheduleView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
      resource: '',
      liveSchedule: '',
      resources: '',
      filteredResources: [],
      items: '',
      optimisticItems: generateItems(this.props.optimisticLiveSchedule),
      optimisticLiveSchedule: this.props.optimisticLiveSchedule,
      optimisticReRender: this.props.optimisticReRender,
      resourceCollectionName: '',
      resourceCollectionId: '',
      startDate: '',
      scheduleFormat: '',
      itemModal: false,
      itemDetails: '',
      tourModalDisplay: '',
      resourceName: '',
      toggleChange: false,
      backRedirect: '',
      selectedItem: {},
      liveScheduleUpdate: false,
      openActionModal: false,
      actionType: ''
    };
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.readyApiCall();
    this.customBrowserBackNavigation();
  }

  customBrowserBackNavigation = () => {
    // event handler for browser back button
    // Note: only works when AppRouter component wraps Switch w/ HashRouter
    window.onpopstate = () => {
      const { pathname } = this.props.history.location;
      if (pathname === '/live-schedule-view-long') {
        this.setState({
          backRedirect: '/schedules'
        });
      }
    }
  }

  readyApiCall = () => {
    const userId = this.props.user.login.id;
    const resourceId = this.props.user.login.resourceId;
    if (this.props.location.state) {
      const { startDate, scheduleFormat, resourceCollectionName, resourceCollectionId } = this.props.location.state;
      this.props.actions.updateLiveScheduleParameters({ startDate, scheduleFormat, resourceCollectionName, resourceCollectionId });
      this.getDataFromApi(startDate, scheduleFormat, resourceCollectionId, userId, resourceId, resourceCollectionName);
    } else {
      const { startDate, scheduleFormat, resourceCollectionName, resourceCollectionId } = this.props.liveScheduleParameters;
      this.getDataFromApi(startDate, scheduleFormat, resourceCollectionId, userId, resourceId, resourceCollectionName);
    }
  }

  getDataFromApi = async (startDate, scheduleFormat, resourceCollectionId, userId, resourceId, resourceCollectionName) => {
    //for api to work start date must start at the beginning of the day
    let momentStartDate = moment(startDate).startOf('day');
    const { scheduleView } = this.props.user.securityLevels;
    await this.props.actions.fetchLiveSchedules(momentStartDate, scheduleFormat, resourceCollectionId, userId, resourceId, scheduleView)
      .catch(error => {
        alert("Loading Live Schedules failed\n" + JSON.stringify(error));
      });
    this.setState({
      resourceCollectionName,
      resourceCollectionId,
      liveSchedule: await this.props.liveSchedule
    }, async () => {
      const parameters = {
        scheduleView,
        // resourceId,
        // listPostedSchedulesArray,
        scheduleFormat,
        startDate,
        groups: generateGroups(this.state.liveSchedule.liveSchedule),
        items: await generateItems(this.state.liveSchedule.liveSchedule, startDate, scheduleType, scheduleFormat,this.props.user.securityLevels)
      };
      this.setState({
        startDate,
        scheduleFormat,
        items: securityFilter(parameters),
        resources: generateGroups(this.state.liveSchedule.liveSchedule)
      }, () => {
        // refresh optimistic data w/ real data
        this.props.actions.updateOptimisticReRenderStatus(false);
        this.props.actions.updateOptimisticSchedule(this.state.liveSchedule.liveSchedule);
        this.setState({
          optimisticItems: this.state.items,
          optimisticLiveSchedule: this.state.liveSchedule.liveSchedule
        });
      });
    });
  }

  handleEditModeToggle = async () => {
    let { editMode } = this.props;
    await this.props.actions.updateEditModeStatus(!editMode);
    message.config({
      top: 60,
    });
    editMode = await this.props.editMode;
    message.success(`Edit mode ${editMode ? 'enabled' : 'disabled'}`);
  };

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  handleItemClick = async (item) => {
    this.setState({
      selectedItem: item,
      optimisticReRender: await this.props.optimisticReRender
    }, async () => {
      let itemDetails = await generateItemDetails(item, this.state, 'liveSchedule');
      if (itemDetails) {  // i.e. do nothing if its a blank item
        this.setState({
          itemModal: true,
          itemDetails
        });
      }
    });
  }

  handleModalCancel = (e) => {
    this.setState({
      itemModal: false,
    });
  }

  handleToggleChange = (redirectInfo) => {
    this.setState({
      scheduleFormat: redirectInfo.scheduleFormat
    }, () => {
      if (redirectInfo.redirect) {
        this.readyApiCall();
      } else {
        this.refreshPage();
      }
    });
  }

  refreshPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  setFilteredResourceArray = (filteredArray) => {
    this.setState({
      filteredResources: []
    }, () => this.setState({ filteredResources: filteredArray })); // <-- James, this is where the magic happens
  }

  handleItemContextSelect = (key) => {
    // mount LiveScheduleUpdate to handle CRUD operations
    if (this.state.selectedItem.itemType) {
      this.setState({
        liveScheduleUpdate: true,
        contextMenuSelection: key.item.props.children, // dropdown selection text
      }, () => {
        this.handleModalCancel();
      });
    }
  }

  // dropdown lists that appear in context menus for items
  selectContextMenuArray = (item) => {
    let menuArray = [];
    if (item && item.itemType === 'tour' && !(item.id.includes('optimistic'))) {  // don't edit optimistic items
      menuArray = contextMenuArrays.tour;
    }
    if (item && item.itemType === 'off-time' && !(item.id.includes('optimistic'))) {
      menuArray = contextMenuArrays.offTime;
      if (!item.dayRequestId) {
        menuArray = menuArray.filter(menu => menu.name !== 'Edit Days Off Request');
      }
    }
    if (item && item.itemType === 'assignment' && !(item.id.toString().includes('optimistic'))) {
      menuArray = contextMenuArrays.assignment;
    }
    if (item && item.itemType === 'off-request' && !(item.id.toString().includes('optimistic'))) {
      menuArray = contextMenuArrays.daysOffRequest;
    }
    return menuArray;
  }

  updateSelectedItem = (item) => {
    this.setState({
      selectedItem: item
    });
  }

  closeLiveScheduleUpdate = (liveScheduleUpdateState) => {
    if (liveScheduleUpdateState) {
      console.log(`liveScheduleUpdateState.crudLoading: ${liveScheduleUpdateState.crudLoading}`); // debug
    }

    if (liveScheduleUpdateState) {
      if (
        !liveScheduleUpdateState.crudError
        && !liveScheduleUpdateState.crudLoading
        && !liveScheduleUpdateState.deleteJobElementLoading
        && !liveScheduleUpdateState.deleteEmptyJobLoading
        ) {
          this.setState({
            liveScheduleUpdate: false
          });
      }
    }
  }

  groupRendererLive = ({ group }) => {
    const props = {
      startDate: this.state.startDate,
      updateOptimisticLiveSchedule: this.updateOptimisticLiveSchedule,
    };
    return groupRendererLive(group, props);
  };

  updateOptimisticLiveSchedule = (newLiveSchedule) => {
    const newItems = generateItems(newLiveSchedule);
    this.setState({
      optimisticLiveSchedule: newLiveSchedule,
      optimisticItems: newItems
    });
  };

  handlePostSchedule = async () => {
    this.setState({ disableButton: true });
    const userId = this.props.user.login.id;
    const { resourceCollectionId } = this.props.liveScheduleParameters;
    const clonedLiveSchedule = _.cloneDeep(this.state.liveSchedule.liveSchedule);
    const clonedStartDate = _.cloneDeep(this.state.startDate);
    const clonedFilteredResources = _.cloneDeep(this.state.filteredResources);

    let filteredLiveSchedule = _.cloneDeep(clonedLiveSchedule);
    // if (clonedFilteredResources.length > 0) {
    //   filteredLiveSchedule = clonedLiveSchedule.filter(el => {
    //     return clonedFilteredResources.some(f => {
    //       return f.id === el.rId;
    //     });
    //   });
    // }

    filteredLiveSchedule = filteredLiveSchedule.filter(el => { // filter out facility schedules
      return el.class !== 'Facility';
    });

    const parameters = {
      resourcesCollectionId: resourceCollectionId,
      startDate: moment(clonedStartDate).format('M/D/YYYY'),
      format: this.state.scheduleFormat,
      userId,
      liveScheduleInput: { liveSchedule: removeObjectIds(filteredLiveSchedule) }, // <--James, this is where the magic happens
      allResourcesList: this.state.resourceCollectionName
    };

    message.config({
      top: 60,
      duration: 5
    });
    await this.props.actions.createPostedSchedule(parameters)
      .then(async () => {
        let response = await this.props.postedScheduleResult;
        if (response.status === true) {
          message.success(response.message);
        } else {
          message.error(response.message.toString());
        }
        this.setState({ disableButton: false });
      })
      .catch(error => {
        alert(error);
      });
  }

  handleButtonClick = (e) => {
    this.setState({
      openActionModal: true,
      actionType: liveScheduleActionsMenu[e.key],
      keyValue: e.key,
      actionModalText: 'Are you sure you want to ' + liveScheduleActionsMenu[e.key].toLowerCase() + '?'
    });
  }

  handleCorrectAction = () => {
    switch (this.state.keyValue) {
      case '0':
        this.handlePostSchedule();
        this.setState({ openActionModal: false });
        break;
      default:
        alert('No action was found');
        this.setState({ openActionModal: false });
    }
  }

  handleCloseActionModal = () => {
    this.setState({ openActionModal: false });
  }

  render() {
    const { selectedItem } = this.state;
    const { optimisticReRender } = this.props;
    if (this.state.backRedirect && !this.props.hamburgerMenu) {
      window.history.pushState(null, null, '#/schedules');
      return <Redirect to={this.state.backRedirect} />
    }

    if (this.state.resources && this.state.items && window.innerWidth && (!optimisticReRender || (optimisticReRender && this.state.optimisticItems))) {
      return (
        <DashboardLayout>
          <PageTitle title={'Live Schedule'} subTitle={this.state.resourceCollectionName} />
          <div style={{ display: 'flex' }}>
            <LiveSchedulesToggle scheduleFormat={this.state.scheduleFormat} onToggleChange={this.handleToggleChange} />
            {AuthLogic.editMode(this.props.user) &&
              (
                <div style={{ marginLeft: 15 }}>
                  {/* Edit Mode <Switch checked={this.props.editMode} onChange={this.handleEditModeToggle} /> */}
                </div>
              )
            }
          </div>
          {
            this.props.editMode ?
              <div>
                {AuthLogic.approvals(this.props.user) && (
                  <ApprovalFindButton resourceCollection={{
                    resourceCollectionName: this.state.resourceCollectionName,
                    resourceCollectionId: this.state.resourceCollectionId
                  }} />
                )}
                <div style={{ paddingBottom: 20 }}>
                  <Dropdown overlay={
                    <Menu onClick={this.handleButtonClick}>
                      {
                        liveScheduleActionsMenu.map((action, index) => (
                          <Menu.Item key={index}>{action}</Menu.Item>
                        ))
                      }
                    </Menu>
                  }>
                    <Button id='select-action' disabled={this.state.disableButton}>Select Action</Button>
                  </Dropdown>
                </div>
                <WorkerMultiSelect
                  workers={this.state.resources}
                  returnFilteredArray={this.setFilteredResourceArray}
                />
              </div>

              : null
          }

          <GanttChartTimeline
            groups={this.state.filteredResources.length === 0 ? this.state.resources : this.state.filteredResources}
            items={!optimisticReRender ? this.state.items : this.state.optimisticItems}
            visibleTimeStart={moment(this.state.startDate).startOf('day')} // must use moment()
            visibleTimeEnd={moment(this.state.startDate).startOf('day').add(this.state.scheduleFormat, 'days')}
            groupRenderer={this.groupRendererLive}
            sidebarWidth={120}  // defaults to 150
            resizeDetector={containerResizeDetector} // prevents blank rightSideBar
            itemRenderer={({ item, timelineContext, itemContext, getItemProps, getResizeProps }) => {
              const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
              const backgroundColor = itemContext.selected ? (itemContext.dragging ? "red" : item.selectedBgColor) : item.backgroundColor;
              const borderColor = itemContext.resizing ? "red" : item.borderColor;
              const resourceName = itemContext.dimensions.order.group.title;
              // console.log('itemContext: ', itemContext.dimensions.order.group); // debug

              if (!itemContext.selected) {
                this.updateSelectedItem({});
              }

              return (
                <React.Fragment>
                  <div
                    {...getItemProps({
                      style: {
                        backgroundColor: backgroundColor || "undefined",
                        color: item.color || "white",
                        borderColor: itemContext.selected ? "black" : borderColor || "",
                        borderStyle: item.borderStyle || "",
                        borderWidth: itemContext.selected ? 1 : 2,
                        borderRadius: 2,
                        borderLeftWidth: itemContext.selected ? 3 : 1,
                        borderRightWidth: itemContext.selected ? 3 : 1,
                      },
                      onMouseUp: async () => {
                        item.resourceName = resourceName;
                        this.handleItemClick(item)
                      },
                      onTouchEnd: () => { // Used to select item in chrome mobile.
                        item.resourceName = resourceName;
                        this.handleItemClick(item);
                      }
                    })}
                    onMouseEnter= {(event) =>{
                      //event.clientX
                      
                      this.setState({ showToolTip: true })
                    }}
                    onMouseLeave= { () =>{
                      this.setState({ showToolTip: false })
                    }}
                  >
                    {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

                    <div
                      style={{
                        height: itemContext.dimensions.height,
                        overflow: "hidden",
                        paddingLeft: 3,
                        textOverflow: "string",
                        fontSize: 10,
                        whiteSpace: "nowrap",
                      }}
                      
                    >
                      {item.tooltipText ? item.tooltipText : itemContext.title}
                    </div>
                    {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                  </div>
                  {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                </React.Fragment>
              );
            }}
            stackItems={true}
            itemHeightRatio={1}
            canChangeGroup={false}
            canMove={this.props.editMode}
            canResize={this.props.editMode}
            fixedHeader={false}
          >
            <TimelineHeaders
              style={{
                position: "sticky",
                top: 0,
                zIndex: 100
              }}
            >
              <SidebarHeader>
                {({ getRootProps }) => {
                  return <div {...getRootProps()}>
                    {/* width must match sidebarWidth */}
                    <h6 style={{ width: 120 }} className="rct-dateHeader-primary">Resource</h6></div>
                }}
              </SidebarHeader>

              < CustomPrimaryDateHeader
                unit="week"
                textAlign="center"
                widescreen={this.state.widescreen}
              />

              < CustomDateHeader
                unit="day"
                textAlign="center"
                widescreen={this.state.widescreen}
              />

            </TimelineHeaders>
          </GanttChartTimeline>
          <Modal
            zIndex={2000}
            title={this.state.itemDetails.title}
            visible={this.state.itemModal}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[
            ]}
          >
            <div>
              {
                <ItemModalDetails
                  itemDetails={this.state.itemDetails}
                  scheduleType={'liveSchedule'}
                  securityLevels={this.props.user.securityLevels}
                />
              }

              {
                this.props.editMode &&
                this.state.itemDetails.resourceClass !== 'Facility' &&
                !this.state.itemDetails.isApproved &&
                <Select
                  value={selectedItem.id && selectedItem.id.toString().includes('optimistic') ? <Mentions style={{ border: 'none', fontWeight: 'bold' }} readOnly placeholder={'Refresh page to Edit'} /> : <Mentions style={{ border: 'none', fontWeight: 'bold' }} readOnly placeholder={'Edit'} />}
                  style={{ marginTop: 10, width: 200 }}
                  dropdownStyle={{ zIndex: 2000 }}
                >
                  {
                    this.selectContextMenuArray(selectedItem).map((elem, i) => {
                      return (
                        elem.authRule &&
                        AuthLogic[`${elem.authRule}`] &&
                        AuthLogic[`${elem.authRule}`](this.props.user) &&
                        <Option
                          key={elem.name}
                          value={elem.name}
                          onClick={(key) => this.handleItemContextSelect(key)}
                        >
                          {elem.name}
                        </Option>
                      );
                    })
                  }
                </Select>
              }
            </div>
          </Modal>
          {
            this.state.openActionModal ?
              <Modal
                title="Confirmation Message"
                visible={this.state.openActionModal}
                onOk={this.handleCorrectAction} // Right now just for posting schedule
                onCancel={this.handleCloseActionModal}
                okText="OK"
                cancelText="CANCEL"
              >{this.state.actionModalText}</Modal> : null
          }

          {this.state.liveScheduleUpdate &&
            <LiveScheduleUpdate
              contextMenuSelection={this.state.contextMenuSelection}
              itemDetails={this.state.selectedItem}
              updateSelectedItem={this.updateSelectedItem}
              closeLiveScheduleUpdate={this.closeLiveScheduleUpdate}
              updateOptimisticLiveSchedule={this.updateOptimisticLiveSchedule}
            />
          }

        </DashboardLayout>
      )
    } else return <Spinner />
  }
}

LiveScheduleView.propTypes = {
  actions: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  liveSchedule: PropTypes.object.isRequired,
  editMode: PropTypes.bool.isRequired,
  optimisticReRender: PropTypes.bool.isRequired,
  optimisticLiveSchedule: PropTypes.array,
  hamburgerMenu: PropTypes.bool.isRequired,
  // listPostedSchedules: PropTypes.object
};

function mapStateToProps(state) {
  return {
    user: state.user,
    liveSchedule: state.liveSchedules,
    editMode: state.editMode.status,
    optimisticReRender: state.liveScheduleOptimisticReRender.status,
    optimisticLiveSchedule: state.liveScheduleOptimisticSchedule.newLiveSchedule,
    hamburgerMenu: state.navigation.hamburgerMenu,
    postedScheduleResult: state.createPostedSchedule,
    liveScheduleParameters: state.liveScheduleParameters
    // listPostedSchedules: state.listPostedSchedules
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchLiveSchedules: bindActionCreators(
        liveScheduleActions.fetchLiveSchedules,
        dispatch
      ),
      updateEditModeStatus: bindActionCreators(
        liveScheduleActions.updateEditModeStatus,
        dispatch
      ),
      updateOptimisticReRenderStatus: bindActionCreators(
        liveScheduleActions.updateOptimisticReRenderStatus,
        dispatch
      ),
      updateOptimisticSchedule: bindActionCreators(
        liveScheduleActions.updateOptimisticSchedule,
        dispatch
      ),
      createPostedSchedule: bindActionCreators(
        postedScheduleActions.createPostedSchedule,
        dispatch
      ),
      updateLiveScheduleParameters: bindActionCreators(
        liveScheduleActions.updateLiveScheduleParameters,
        dispatch
      )
      //   fetchListPostedSchedules: bindActionCreators(
      //     postedScheduleActions.fetchListPostedSchedules,
      //     dispatch
      // )
    }
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveScheduleView));



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/LiveScheduleView.js